<template>
  <Dialog 
    :header="title"
    :visible="display"
    :style="{ width: '70vw' }"
    :modal="true"
    :closeOnEscape="false"
    :contentStyle="{ overflow: 'visible' }"
    closable
    @update:visible="CloseModal"
  >
    <div class="p-p-4">
      <div class="p-fluid p-grid">       
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <AutoComplete v-model='order.symbol' :dropdown="true" :suggestions="filteredSymbols" @complete="SearchSymbol($event)" autofocus/>
            <label for="Symbol">Symbol</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <AutoComplete v-model='order.symbolAggregate' :dropdown="true" :suggestions="filteredSymbols" @complete="SearchSymbol($event)"/>
            <label for="SymbolAggregate">Symbol Aggregate</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <Calendar id="icon" v-model="orderDate" dateFormat="dd/mm/yy" :showIcon="true" />
            <label for="calendar">Calendar</label>
          </span>
        </div>          
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <AutoComplete v-model='order.accountNumber' :dropdown="true" :suggestions="filteredAccounts" @complete="SearchAccount($event)"/>
            <label for="inputtext">Account Number</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <InputText type="text" v-model="order.numDoc" />
            <label for="inputtext">Num Doc</label>
          </span>
        </div>        
        <div class="p-field p-col-12 p-md-4">
          <span class="p-float-label">
            <AutoComplete v-model='order.portfolio' :dropdown="true" :suggestions="filteredPortfolio" @complete="SearchPortfolio($event)"/>
            <label for="inputtext">Portfolio</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <Dropdown v-model="order.action" :options="actions" optionValue="value" optionLabel="name" placeholder="Select a Action" />
        </div>        
        <div class="p-field p-col-12 p-md-3">
          <Dropdown v-model="order.type" :options="types" optionValue="value" optionLabel="name" placeholder="Select a Type" />
        </div>
        <div class="p-field p-col-12 p-md-3" v-if='isOption'>
          <span class="p-float-label">
            <Calendar id='expirationDate' v-model="expirationDate" :showIcon="true" />
            <label for="expirationDate">Expiration Date</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-2" v-if='isOption'>
          <span class="p-float-label">
            <InputNumber id='strikePrice' v-model="order.strikePrice" mode="currency" currency="USD" locale="en-US" :minFractionDigits="2" :maxFractionDigits="4" />
            <label for="strikePrice">Strike Price</label>
          </span>
        </div>
        <div class="p-field-checkbox p-col-12 p-md-1 p-d-flex p-ai-center" v-if='isOption'>
          <Checkbox id='exercised' v-model="order.exercised" :binary="true" />
          <label for="exercised" class="p-ml-2">Exercised?</label>
        </div>        
        <div class="p-md-6" v-if='!isOption'>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <span class="p-float-label">
            <InputNumber v-model="order.quantity" mode="decimal"/>
            <label for="inputnumber">Quantity</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <span class="p-float-label">
            <InputNumber v-model="order.price" mode="currency" currency="USD" locale="en-US" />
            <label for="inputmask">Price</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <span class="p-float-label">
            <InputNumber v-model="order.otherCost" mode="currency" currency="USD" locale="en-US" />
            <label for="inputmask">Other Cost</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <span class="p-float-label">
            <InputNumber v-model="order.comission" mode="currency" currency="USD" locale="en-US" />
            <label for="inputmask">Comission</label>
          </span>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <span class="p-input-icon-right">
              <InputText type="text" v-model="order.externalId" />
              <i class="pi pi-refresh hand" @click="GenerateExternalId" />
          </span>          
        </div>              
        <div class="p-field p-col-12 p-md-6">
          <Dropdown v-model="order.idTenant" :options="tenants" optionValue="id" optionLabel="name" placeholder="Select a Tenant" />
        </div>        
      </div>

      <p v-if="notifications">
        <ul>
          <li v-for="(notification, index) in notifications" :key=(index) class='p-text-left text-danger'>{{ notification.message }}</li>
        </ul>
      </p>      
    </div>
    <template #footer>
      <div class="p-grid">
        <div class="p-col-4 a0045cfe02ba4" title="Amount">
            <span class="balanceValues" :class="[order.action === 1 ? 'positiveValue' : 'negativeValue']">{{ $formatCurrency(amount) }}</span>
        </div>
        <div class="p-col-4">
          <Button label="Expired" icon="pi pi-pause" class="p-button-warning" @click='QuestionExpired' v-show='isOption' />
          <Button label="Exercise" icon="pi pi-forward" class="p-button-warning" disabled="disabled" v-show='isOption' />
        </div>
        <div class="p-col-4">
          <Button label="Delete" icon="pi pi-trash" class="p-button-danger" @click='QuestionDelete' v-show='deletable' />
          <Button label="No" icon="pi pi-times" class="p-button-secondary" @click='Cancel' />
          <Button label="Save" icon="pi pi-save" class="p-button-success" @click='Save' />
        </div>
      </div>
    </template>
    
  </Dialog>
</template>

<script>
import CompanyService from '@/services/CompanyService.js'
import AccountService from '@/services/AccountService.js'
import PortfolioService from '@/services/PortfolioService.js'
import OrderService from '@/services/OrderService.js'
import Calendar from 'primevue/calendar'
import { Guid } from '@/tools/Common.js'

export default {
  name: 'Order',
  components: { Calendar },
  props: {
    idOrder: null,
    draft: { type: Object, default: null }
  },
  data() {
    return {
      display: true,
      deletable: false,
      companyService: null,
      orderService: null,
      accountService: null,
      portfolioService: null,
      symbols: null,
      accounts: null,
      portfolios: null,
      filteredSymbols: null,
      filteredAccounts: null,
      order: {
        action: 0,
        type: 0,
        symbol: null,
        symbolAggregate: null, 
        accountNumber: null,       
        date: new Date(),
        quantity: 0,
        price: 0,
        strikePrice: null,
        otherCost: 0,
        comission: 0,
        amount: 0,
        idTenant: null
      },
      notifications: null,
      actions: [
        { name: 'Buy', value: 0 },
        { name: 'Sell', value: 1 }
      ],
      types: [
        { name: 'Stock', value: 0 },
        { name: 'Put', value: 1 },
        { name: 'Call', value: 2 },
      ]
    }
  },
  computed: {
    title () {
      return (this.isOption ? 'Option Order' : 'Order') +  ' [ ' + this.order.idOrder + ' ]'
    },
    amount () {
      try {
        var subtotal = this.order.quantity * this.order.price
        var costs = this.order.otherCost + this.order.comission
        return this.order.action === 0 ? subtotal + costs : subtotal - costs
      } catch (ex) {
        return 0
      }
    },
    tenants () {
      return this.$store.getters.Tenants
    },
    isOption () {
      return this.order.type === 1 || this.order.type === 2
    },
		expirationDate: {
			get(){
				return this.$formatDate(this.order.expirationDate)
			},
			set(newVal){
				this.order.expirationDate = newVal
			}
		},
		orderDate: {
			get(){
				return this.$formatDate(this.order.date)
			},
			set(newVal){
				this.order.date = newVal
			}
		}        
  },
  async created() {
    this.$store.commit('Busy', true)
    this.companyService = new CompanyService()
    this.orderService = new OrderService()
    this.accountService = new AccountService()
    this.portfolioService = new PortfolioService()
  },
  async mounted() {    
    if(this.idOrder) {
      this.order = await this.orderService.GetOrder(this.idOrder)      
      this.deletable = true
    } 
    else 
    {
      this.order.accountNumber = this.$store.getters.WorkAccount
      this.order.date = this.$store.getters.WorkDate ?? new Date()
      this.order.idOrder = this.$guid()
      if(this.draft) {
        this.order = { ...this.order, ...this.draft, idOrder: this.$guid() }
      }
    }

    this.symbols = await this.companyService.GetDistinctSymbols()
    this.accounts = await this.accountService.GetDistinctAccounts()
    this.portfolios = await this.portfolioService.GetDistinctPortfolios()
    this.$store.commit('Busy', false)
  },
  methods: {
    GenerateExternalId () {
      this.order.externalId = Guid()
    },
    SearchSymbol(event) {
      if (!event.query.trim().length) {
        this.filteredSymbols = [...this.symbols]
      }
      else {
        this.filteredSymbols = this.symbols.filter((symbol) => {
          return symbol.toUpperCase().startsWith(event.query.toUpperCase())
        })
      }
    },
    SearchAccount(event) {      
      if (!event.query.trim().length) {
        this.filteredAccounts = [...this.accounts]
      }
      else {
        this.filteredAccounts = this.accounts.filter((account) => {
          return account.toUpperCase().startsWith(event.query.toUpperCase())
        })
      }
    },
    SearchPortfolio(event) {      
      if (!event.query.trim().length) {
        this.filteredPortfolio = [...this.portfolios]
      }
      else {
        this.filteredPortfolio = this.portfolios.filter((portfolio) => {
          return portfolio.toUpperCase().startsWith(event.query.toUpperCase())
        })
      }
    },    
    CloseModal () {
      this.$emit('close-modal')
    },
    async Save () {
      this.$store.commit('Busy', true)
      try {
        await this.orderService.Save(this.order)
        this.$emit('saved', this.order)
        this.$store.commit('Busy', false)
        this.$emit('close-modal')
      }
      catch (e) {
        console.error(e)
        this.TreatError(e)        
      }
      finally {
        this.$store.commit('Busy', false)
      }
    },
    QuestionExpired () {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "Do you want to create a new expired order based on this?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, create!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.CreateOrderExpired()
        }
      })      
    },
    QuestionDelete () {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete this record?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.Delete()
        }
      })      
    },
    Cancel () {
      this.$emit('close-modal')
    },
    async Delete () {
      try {
        await this.orderService.Delete(this.idOrder)
        this.$emit('close-modal')
        this.$emit('deleted')
        this.$store.commit('OrderDeleted', this.order.idOrder)
      } catch (e) {
        console.error(e)
      }
    },
    async CreateOrderExpired () {
      try {
        var response = await this.$http.get(`/api/order/${this.order.idOrder}/expired/create`)
        this.order = response.data.data
      } catch (error) {
        console.error(error)
      }
    },
    TreatError(error) {
      if (error.response && error.response.status === 422 && error.response.data.valid === false) {
        this.notifications = error.response.data.notifications
      }      
    }
  }
}
</script>

<style>
.a0045cfe02ba4 {
  font-weight: 700;
  padding-top: 5px;
  font-size: 1.7rem;    
}
</style>
